//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Ranson',
  components: {},
  data () {
    return {
      form: {
        age: '0',
        whiteBloodCell: '0',
        glucose: '0',
        lDH: '0',
        aST: '0',
        redCell: '0',
        bun: '0',
        ca: '0',
        PaO2: '0',
        baseDeficit: '0',
        fluidRequirements: '0'
      },
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = form.age + form.whiteBloodCell + form.glucose + form.lDH + form.aST + form.redCell + +form.bun + form.ca + form.PaO2 + +form.baseDeficit + form.fluidRequirements
      self.hasScore = true
      if (result < 3) {
        self.descTxt = '死亡率0~3%'
      } else if (result > 2 && result < 6) {
        self.descTxt = '死亡率11%~15%'
      } else if (result > 5) {
        self.descTxt = '提示死亡率≥40%'
      }
      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/GIT/Ranson.vue